import translations from '../files/en.json';
export const locale = {
  lang: 'en',
  data: Object.assign({}, translations),
};
